import React from 'react';

import { Alert, Button, Stack } from '@mui/material';

interface ExpiredFareAlertProps {
  onRefresh: () => void;
  refreshing: boolean;
  subject: string;
}

export default function ExpiredFareAlert({ onRefresh, refreshing, subject }: ExpiredFareAlertProps) {
  return (
    <Alert severity="warning">
      <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} gap={1}>
        <span>
          The validated fare has expired. Prices and availability change, so refresh it through the customer search
          before reviewing {subject} for publication.
        </span>
        <Button size="small" variant="outlined" onClick={onRefresh} disabled={refreshing} sx={{ whiteSpace: 'nowrap' }}>
          {refreshing ? 'Refreshing…' : 'Refresh fare and draft'}
        </Button>
      </Stack>
    </Alert>
  );
}
